/* eslint-disable react-refresh/only-export-components */
import { createContext, Dispatch, FC, Reducer, useReducer } from 'react';

import { PropsWithOnlyChildren } from 'app/types';

export interface BaseFileData {
  extension: string;
  file: File;
  imageTypeId?: null | number;
  name: string;
  size: number;
  type: string;
}
export interface FileData extends BaseFileData {
  data: string;
}

interface State {
  isBillSubmitting: boolean;
}

interface ResetAction {
  type: 'reset';
}
interface SetIsBillSubmittingAction {
  payload: {
    isBillSubmitting: boolean;
  };
  type: 'setIsBillSubmitting';
}

export type PaperworkContextAction =
  | ResetAction
  | SetIsBillSubmittingAction;

type PaperworkDispatch = Dispatch<PaperworkContextAction>;

const initialState: State = {
  isBillSubmitting: false,
};

export const PaperworkStateContext = createContext<State>(initialState);
export const PaperworkDispatchContext = createContext<PaperworkDispatch>(undefined as unknown as PaperworkDispatch);

PaperworkStateContext.displayName = 'PaperworkState';
PaperworkDispatchContext.displayName = 'PaperworkDispatch';

const reducer: Reducer<State, PaperworkContextAction> = (state, action) => {
  switch (action.type) {
    case 'reset':
      return { ...initialState };

    case 'setIsBillSubmitting':
      return {
        ...state,
        isBillSubmitting: action.payload.isBillSubmitting,
      };

    default:
      throw new Error();
  }
};

const PaperworkContextProvider: FC<PropsWithOnlyChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PaperworkStateContext.Provider value={state}>
      <PaperworkDispatchContext.Provider value={dispatch}>
        {children}
      </PaperworkDispatchContext.Provider>
    </PaperworkStateContext.Provider>
  );
};

export default PaperworkContextProvider;
